<template>
<div class="hc-stackedbar">
  <svg :style="style" class="hc-stackedbar-chart">
    <bar
      v-for="bar in bars"
      :key="bar.id"
      :id="bar.id"
      :x="bar.x"
      :width="bar.width"
      :height="height * .95"
      :data="bar.data"
      :max="max"
      :animation="animation"
      :animationDuration="animationDuration"
      :animationOptions="animationOptions"
      :color-scale="colorScale"
    />
    <text-axis
      :scaleFunction="bandScale"
      :scale="scale"
      :height="height * .85"
      :offset="offset"
      color="#666"
      :data="data"
    />
  </svg>
  <text-legend :data="legend"/>
</div>
</template>

<script>
import Bar from '../shapes/Bar'
import TextAxis from '../libraries/TextAxis'
import TextLegend from '../combo/TextLegend'
import { scaleBand, scaleOrdinal } from 'd3-scale'
export default {
  name: 'StackedBarChart',
  components: {
    Bar,
    TextAxis,
    TextLegend
  },
  props: {
    data: {
      type: Array,
      default () { return []}
    },
    animation: {
      type: Boolean,
      default: true
    },
    animationDuration: {
      type: Number,
      default: 3000
    },
    animationOptions: {
      type: Object,
      default () {
        return {
          delay: 0,
          easing: 'Bounce',
          easingEdge: 'Out'
        }
      }
    }
  },
  data () {
    return {
      width: 1000,
      height: 500
    }
  },
  mounted () {
    this.resize()
    window.addEventListener('resize', this.resize)
  },
  methods: {
    resize () {
      this.width = this.$el.offsetWidth
      this.height = this.$el.offsetHeight
    }
  },
  computed: {
    style () {
      return { height: `${this.height}px`, width: `${this.width}px` }
    },
    scale () {
      return Math.sqrt(this.height / 500)
    },
    max () {
      return Math.max(...this.data.map(d => d.data.reduce((acc, cv) => acc + cv.value, 0)))
    },
    offset () {
      return { top: 0, left: 0, bottom: this.height * .1, right: 0 }
    },
    legend () {
      return this.data.map(d => d.data)
        .flat()
        .map(d => d.name)
        .filter((d, i, self) => self.indexOf(d) === i)
        .map((d, i) => { return {name: d, color: this.colorScale(i)}})
      
    },
    colorScale () {
      return scaleOrdinal()
        .range(['#f56043', '#333', '#666', '#999', '#bbb', '#faa795', '#fcc3b8'])
        .domain([0, 1, 2, 3, 4, 5, 6])
    },
    bandScale () {
      return scaleBand()
        .rangeRound([0, this.width])
        .domain(this.data.map(d => d.year))
        .padding(0.1)
    },
    bars () {
      let bars = []
      for (let i = 0; i < this.data.length; i++) {
        bars.push({
          x: this.bandScale(this.data[i].year),
          width: this.bandScale.bandwidth(),
          data: this.data[i].data,
          id: i + 1
        })
      }
      return bars
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resize)
  }
}
</script>

<style>

</style>
